/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FormElementInfoDto } from '../models/FormElementInfoDto';
import type { PeopleMigrationRequestDto } from '../models/PeopleMigrationRequestDto';
import type { PeopleMigrationResultDto } from '../models/PeopleMigrationResultDto';
import type { PersonFieldInfoDto } from '../models/PersonFieldInfoDto';
import type { PersonMappingGroupDto } from '../models/PersonMappingGroupDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class PersonMigrationService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Get all form elements for a form definition, structured as a tree.
     * Used by the mapping UI to display available form elements.
     * @param orgGuid
     * @param formDefinitionGuid
     * @returns FormElementInfoDto OK
     * @throws ApiError
     */
    public getFormElements(
        orgGuid: string,
        formDefinitionGuid: string,
    ): CancelablePromise<Array<FormElementInfoDto>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/PersonMigration/{orgGuid}/{formDefinitionGuid}/GetFormElements',
            path: {
                'orgGuid': orgGuid,
                'formDefinitionGuid': formDefinitionGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Get the list of available Person table fields that form elements can be mapped to.
     * @returns PersonFieldInfoDto OK
     * @throws ApiError
     */
    public getPersonFields(): CancelablePromise<Array<PersonFieldInfoDto>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/PersonMigration/GetPersonFields',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Get all mapping groups for a form definition, including their field mappings.
     * @param orgGuid
     * @param formDefinitionGuid
     * @returns PersonMappingGroupDto OK
     * @throws ApiError
     */
    public getMappingGroups(
        orgGuid: string,
        formDefinitionGuid: string,
    ): CancelablePromise<Array<PersonMappingGroupDto>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/PersonMigration/{orgGuid}/{formDefinitionGuid}/GetMappingGroups',
            path: {
                'orgGuid': orgGuid,
                'formDefinitionGuid': formDefinitionGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Save all mapping groups for a form definition. Replaces existing groups entirely.
     * This is a bulk save operation — send the full list of groups with field mappings.
     * @param formDefinitionGuid
     * @param orgGuid
     * @param sysOrgGuid
     * @param requestBody
     * @returns PersonMappingGroupDto OK
     * @throws ApiError
     */
    public saveMappingGroups(
        formDefinitionGuid: string,
        orgGuid: string,
        sysOrgGuid?: string,
        requestBody?: Array<PersonMappingGroupDto>,
    ): CancelablePromise<Array<PersonMappingGroupDto>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/PersonMigration/{orgGuid}/{formDefinitionGuid}/SaveMappingGroups',
            path: {
                'formDefinitionGuid': formDefinitionGuid,
                'orgGuid': orgGuid,
            },
            query: {
                'sysOrgGuid': sysOrgGuid,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Preview the migration: dry-run that shows what Person/Entity records would be created.
     * @param requestBody
     * @returns PeopleMigrationResultDto OK
     * @throws ApiError
     */
    public previewMigration(
        requestBody?: PeopleMigrationRequestDto,
    ): CancelablePromise<PeopleMigrationResultDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/PersonMigration/PreviewMigration',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Execute the migration: creates Person and Entity records from form response data.
     * @param requestBody
     * @returns PeopleMigrationResultDto OK
     * @throws ApiError
     */
    public executeMigration(
        requestBody?: PeopleMigrationRequestDto,
    ): CancelablePromise<PeopleMigrationResultDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/PersonMigration/ExecuteMigration',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
}
